import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';

import controller from './bulk-delete-archived-report-instances-dialog.controller';
import template from './bulk-delete-archived-report-instances-dialog.html';

import bulkDeleteArchivedReportInstance from './bulkDeleteArchivedReportInstance';
import bulkDeleteArchivedReportInstancesConfirmDialog from '../dialog.bulkDeleteArchivedReportInstancesConfirmDialog';

class dialogService {
  getOptions($event, { reportType, reportInstances }) {
    return {
      controller,
      controllerAs: 'bulkDeleteArchivedReportInstancesDialogVM',
      locals: {
        reportType,
        reportInstances,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.reports.archivedReports.reportType.bulkDeleteArchivedReportInstancesDialog', [
  ngCookies,
  constants,
  reportsDataService,
  ssDialogService,
  alerts,
  loaderService,
  bulkDeleteArchivedReportInstance,
  bulkDeleteArchivedReportInstancesConfirmDialog,
])
  .service('bulkDeleteArchivedReportInstancesDialog', dialogService)
  .name;

console.log('app.components.reports.archivedReports.reportType.bulkDeleteArchivedReportInstances created');
